<template>
  <v-card v-if="monoEmitter != null" elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Información del monotributo</h6>
      <p class="text-body-2">Información relevante sobre los maximos permitidos de facturación</p>
      <v-row>
        <v-col>
          <v-chip outlined color="primary" class="mr-2 mb-2">Max. permitido: {{ billingText(monoEmitter.allowed_month_limit * 12 - last_year_billing) }} </v-chip>
          <v-chip outlined class="mr-2 mb-2">Limite mensual sugerido: {{ formatUtils.formatPrice(monoEmitter.allowed_month_limit) }} </v-chip>
          <v-chip outlined class="mr-2 mb-2">Facturado ultimo 12 meses: {{ billingText(last_year_billing) }} </v-chip>
          <v-chip outlined class="mr-2 mb-2">Tope categoria de monotributo: {{ formatUtils.formatPrice(monoEmitter.allowed_month_limit * 12) }} </v-chip>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { emmiterService } from "@/libs/ws/emmiterService";
import { formatUtils } from "@/libs/utils/formatUtils";
export default {
  components: {},
  props: { invoice: Object },
  data: () => ({
    emmiterService: emmiterService,
    formatUtils: formatUtils,
    last_year_billing: null,
    loading_billing: false,
    billing_request_id: 0,
  }),
  computed: {
    monoEmitter() {
      const emitter = this.invoice.emitter;
      return emitter != null && emitter.iva_condition != undefined && emitter.iva_condition.id == emmiterService.CONDITION_IVA_MONO ? emitter : null;
    },
  },
  watch: {
    monoEmitter: {
      immediate: true,
      handler: "loadLastYearBilling",
    },
  },
  methods: {
    loadLastYearBilling(emitter) {
      //Evita que una respuesta vieja pise la del emisor actual
      const request_id = ++this.billing_request_id;
      this.last_year_billing = null;
      this.loading_billing = emitter != null;
      if (emitter == null) return;

      emmiterService
        .lastYearBilling(emitter.id)
        .then((response) => {
          if (request_id !== this.billing_request_id) return;
          this.last_year_billing = response.status ? response.result : null;
          this.loading_billing = false;
        })
        .catch(() => {
          if (request_id === this.billing_request_id) this.loading_billing = false;
        });
    },
    billingText(amount) {
      if (this.loading_billing) return "Calculando...";
      return this.last_year_billing === null ? "-" : formatUtils.formatPrice(amount);
    },
  },
};
</script>
